import { z } from 'zod'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

import { Salt } from '../../../cross-chain-deployment/Salt'

export const SaltSchema = z.string()

type SaltReportText = z.infer<typeof SaltSchema>

export function mapDomainToReportText(
  postDeploymentModule: Salt
): SaltReportText {
  return postDeploymentModule.getValue().getValue()
}

export function mapReportTextToDomain(reportText: SaltReportText): Salt {
  return Salt.create({
    saltValue: HexNumber.create({
      hexNumberValue: reportText,
    }),
  })
}
